module.exports = __webpack_public_path__ + "media/images/arrow-d6f60b89.png";